export const Alarm = {
    path: '/alarms',
    name: 'alarms',
    component: () => import('@/views/Notification/Alarm/AlarmPage.vue'),
    children: [
        // Parent
        {
            path: '/alarms/add',
            name: 'alarms.add',
            component: () => import('@/views/Notification/Alarm/Form/AlarmForm.vue'),
            props: {addAction: true}
        },
        {
            path: '/alarms/edit/:id',
            name: 'alarms.edit',
            component: () => import('@/views/Notification/Alarm/Form/AlarmForm.vue'),
            props: {updateAction: true}
        },
        {
            path: '/alarms/delete/:id',
            name: 'alarms.delete',
            component: () => import('@/views/Notification/Alarm/Form/AlarmForm.vue'),
            props: {deleteAction: true}
        },
        {
            path: '/alarms/view/:id',
            name: 'alarms.view',
            component: () => import('@/views/Notification/Alarm/Form/AlarmForm.vue'),
            props: {viewAction: true}
        },
    ]
}